import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { JustificadoForm } from './JustificadoForm';
// import { usePay } from '../../../hooks/usePay';

export const JustificadoModal = ({ title, openModal, setModal, checkInitialData, dataCompra, initGetAllPayByGasto }) => {

    return (
        <Dialog
            className='dialogoCrearPagos'
            open={openModal}
            onClose={() => setModal(false)}
            aria-labelledby="simple-dialog-title"
        >
            <div className='ContainerDialogs'>
                <h1 className='TitleModalPresupuesto'>
                    Justificar gasto
                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={() => setModal(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </h1>

                <JustificadoForm
                    setModal={setModal}
                    dataCompra={dataCompra}
                    checkInitialData={checkInitialData}
                    initGetAllPayByGasto={initGetAllPayByGasto}
                />

            </div>
        </Dialog>
    )
}
